import { type IColumn, Typography } from 'shared/ui'
import { type UrlShortener } from 'entities/ShortLink/model/UrlShortener'
import { UrlShortenerStatus } from 'pages/settings/pages/urlShortener/ui/UrlShortenerStatus/UrlShortenerStatus'
import { ActivateButton } from 'pages/settings/pages/urlShortener/ui/UrlShortenerAction/UrlShortenerAction'

export const columns = (): IColumn<UrlShortener>[] => [
  {
    field: 'label',
    name: 'Short link domain',
    width: '50%',
    renderRowCell: (row) => {
      return (
        <Typography ellipsis tag='div' variant={'body-md-regular'} ariaLabel='shortLinkName'>
          {row.domain}
        </Typography>
      )
    },
  },
  {
    field: 'status',
    name: 'Status',
    renderRowCell: (row) => {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '10px',
          }}
        >
          <UrlShortenerStatus item={row} />
          <ActivateButton />
        </div>
      )
    },
  },
]
